import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { useSelector } from 'react-redux';
import { userInfoSelector } from '../state';
import UserAvatar from './UserAvatar';

export const Container = styled('div')(() => ({
  textAlign: 'center',
}));

export const TypographyUser = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey[500],
}));

const UserAppInfo = () => {
  const { username, name } = useSelector(userInfoSelector) || { name: '', username: '' };
  return (
    <Container>
      <UserAvatar
        sx={{
          width: 130,
          height: 130,
          fontSize: 'xxx-large',
          margin: 'auto',
        }}
      />
      <Typography variant="h6">{name}</Typography>
      <TypographyUser variant="body2">{username}</TypographyUser>
      <TypographyUser variant="body2">{`Flex Conciliations v${process.env.VERSION}`}</TypographyUser>
    </Container>
  );
};

export default UserAppInfo;
